import { useContext } from 'react';
import { useQuery } from 'react-query';
import { InformacaoTelasAcessadasContext } from '~/context/InformacaoTelasAcessadas';
import api from '~/services/api';

interface UseLinkMaterialQuery {
  data: string | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export const useLinkMaterial = (codTela: number): UseLinkMaterialQuery => {
  const { screensInformacoes } = useContext(InformacaoTelasAcessadasContext);

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['linkMaterial', codTela],
    queryFn: async () => {
      const materialLocal = screensInformacoes.find(
        (item) => item.cod_tela === codTela,
      );

      if (materialLocal?.linkMaterial) return materialLocal.linkMaterial;

      const { data: dataLink } = await api.get(`telasLinkMaterial/${codTela}`);

      if (dataLink.success && dataLink.data?.link_material)
        return dataLink.data.link_material;

      return '';
    },
    enabled: !!codTela,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 30,
  });

  return { data, isLoading, isError, refetch };
};
